import { memo, useCallback } from 'react';

import { TwoFactorAuthentication } from '@/legacy/features/user/twoFactorAuthentication/twoFactorAuthentication';

import LoginPopupMultipleMethodsPresentation from './LoginPopupMultipleMethods.presentation';
import useLoginPopupMultipleMethods from './useLoginPopupMultipleMethods';

interface Props {
  code: string;
  errorMessage: string;
  isLoading: boolean;
  isOpen?: boolean;
  onClose: () => void;
  onCodeUpdate: (code: string) => void;
  onRememberDeviceChange: (rememberDevice: boolean) => void;
  onSubmitCode: () => void;
  onTwoFactorAuthenticationChange: (
    selectedTwoFactorAuthentication: TwoFactorAuthentication
  ) => void;
  onClearInput: () => void;
  onCallMe: () => void;
  rememberDevice: boolean;
  selectedTwoFactorAuthentication: TwoFactorAuthentication;
  twoFactorAuthentications: Array<TwoFactorAuthentication>;
  onResendCode: () => void;
}

const LoginPopupMultipleMethods = (props: Props): React.JSX.Element => {
  const {
    code,
    errorMessage,
    isLoading = true,
    isOpen = false,
    onClose,
    onCodeUpdate,
    onRememberDeviceChange,
    onSubmitCode,
    onClearInput,
    onTwoFactorAuthenticationChange,
    onResendCode,
    onCallMe,
    rememberDevice,
    selectedTwoFactorAuthentication,
    twoFactorAuthentications,
  } = props;

  const [state, actions] = useLoginPopupMultipleMethods({
    onClose,
    onSubmitCode,
    onClearInput,
  });

  const handleCodeUpdated = useCallback(
    (verificationCode: string) => {
      const filteredCode = verificationCode.replace(/[^0-9]+/g, '');
      onCodeUpdate(filteredCode);
    },
    [onCodeUpdate]
  );

  return (
    <LoginPopupMultipleMethodsPresentation
      code={code}
      errorMessage={errorMessage}
      isLoading={isLoading}
      isOpen={isOpen}
      onBackPressed={actions.stepBack}
      onCodeUpdated={handleCodeUpdated}
      onNextPressed={actions.stepForward}
      onProviderChange={onTwoFactorAuthenticationChange}
      onRememberDeviceChange={onRememberDeviceChange}
      onResendCode={onResendCode}
      onCallMe={onCallMe}
      rememberDevice={rememberDevice}
      selectedTwoFactorAuthentication={selectedTwoFactorAuthentication}
      step={state.step}
      twoFactorAuthentications={twoFactorAuthentications}
    />
  );
};

export default memo(LoginPopupMultipleMethods);
